import { render, staticRenderFns } from "./MetricEditor.vue?vue&type=template&id=359b3ff8"
import script from "./MetricEditor.vue?vue&type=script&lang=js"
export * from "./MetricEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports